import { gql } from '@/__generated__/gql'

export const YIContentQuery = gql(`
  query YIContentList(
    $offset: Int = 0,
    $limit: Int = 25,
    $order: [[String]],
    $where: ContentWhereInput = {},
    $contentReferencesTo: [ContentContentReferencesToFilterInput] = []
    ) {
      contentList(offset: $offset, limit: $limit, order: $order, where: $where, contentReferencesTo: $contentReferencesTo) {
        content {
          ...Common_ContentFragment
          ...YIClass_ContentFragment
          ...GaiaVideo_ContentFragment
          ...YICourse_ContentFragment
          ...YICourseSection_ContentFragment
          ...YIPose_ContentFragment
          ...YICourseSales_ContentFragment
          ...YIMemberPromo_ContentFragment
          ...YIHomepageHero_ContentFragment
          ...YISeries_ContentFragment
          ...YIArticle_ContentFragment
          ...YICourseModule_ContentFragment
          ...YITeacher_ContentFragment
          ...YITag_ContentFragment
          ...YITagGroup_ContentFragment
        }
      }
    }
`)
